// import React, { useEffect, useState } from "react";
// import { MdOutlineWidgets } from "react-icons/md";
// import { PiTShirt } from "react-icons/pi";
// import { LuClipboardList } from "react-icons/lu";
// import { Link, useLocation } from "react-router-dom";
// import { TbCube } from "react-icons/tb";
// import { RiShoppingBag4Line } from "react-icons/ri";
// import { CiCreditCard1 } from "react-icons/ci";
// import { PiConfettiBold } from "react-icons/pi";
// import { BsCardList } from "react-icons/bs";
// import { BsCardChecklist } from "react-icons/bs";
// import { FaAlignCenter, FaBlog, FaDatabase, FaJediOrder, FaList, FaProductHunt, FaRepublican, FaTractor, FaTrademark, FaUsers } from "react-icons/fa";
// import { AiTwotoneShop } from "react-icons/ai";
// import { Fa42Group, FaFaceGrinSquintTears, FaRightToBracket, FaShop, FaSpaghettiMonsterFlying } from "react-icons/fa6";

// const SlideToTop = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);
// };

// const Sidebar = () => {
//   const [openMenu, setOpenMenu] = useState(null);
//   const [openSellerProduct, setOpenSellerProduct] = useState(false);


//   const toggleMenu = (menu) => {
//     setOpenMenu(openMenu === menu ? null : menu);
//   };

//   return (
//     <div>
//       <SlideToTop />
//       <div className="main-nav">
//         {/* Sidebar Logo */}
//         <div className="logo-box">
//           <Link to="/" className="logo-dark">
//             <img src="/images/logo.jpeg" className="logo-sm" alt="logo sm" />
//             <img src="/images/logo.jpeg" className="logo-lg" alt="logo dark" style={{ height: "100px" }} />
//           </Link>
//           <Link to="/" className="logo-light">
//             <img src="/images/logo.jpeg" className="logo-sm" alt="logo sm" />
//             <img src="/images/logo.jpeg" className="logo-lg" alt="logo light" />
//           </Link>
//         </div>
//         {/* Menu Toggle Button (sm-hover) */}
//         <button
//           type="button"
//           className="button-sm-hover"
//           aria-label="Show Full Sidebar"
//         >
//           <i className="bx bx-menu button-sm-hover-icon" />
//         </button>
//         <div className="scrollbar" data-simplebar="">
//           <ul className="navbar-nav" id="navbar-nav">
//             <li className="menu-title">General</li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/admin-dashboard">
//                 <span className="nav-icon">
//                   <MdOutlineWidgets />
//                 </span>
//                 <span className="nav-text"> Dashboard </span>
//               </Link>
//             </li>
//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("master")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon"><LuClipboardList /></span>
//                 <span className="nav-text">Master</span>
//               </div>

//               {openMenu === "master" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/category-list">
//                       Categories
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/sub-category-list">
//                       Sub-Category
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/product-list">
//                       Product
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/attribute-list">
//                       Attribute
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/brand-list">
//                       Brand
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/color-list">
//                       Color
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/size-list">
//                       Size
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/unit-list">
//                       Product Unit
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/discount-list">
//                       Discount
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("websitemanager")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <LuClipboardList />
//                 </span>
//                 <span className="nav-text">Website Manager</span>
//               </div>

//               {openMenu === "websitemanager" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Banner">
//                       Banner Master
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Rising">
//                       Top Deals
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Fashiontopdeals">
//                       Fashion Top Deals
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/ShopFavorites">
//                       Shop Your Favorites
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Offer">
//                       Special Offers
//                     </Link>
//                   </li>

//                   {/* <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Offer">
//                       Fashion Top Deals
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Offer">
//                       Shop Your Favorites
//                     </Link>
//                   </li> */}

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/GlobalBrand">
//                       Grand Global Brands
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/ShopByCategory">
//                       Shop By Category
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/ShopByCategory">
//                       Product Section
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/TopPick">
//                       Top Pick
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/CrazyDeals">
//                       Crazy Deals
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Productfu">
//                       Products for you
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Advertisement">
//                       Advertisement
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("Sellerprodlist")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <RiShoppingBag4Line />
//                 </span>
//                 <span className="nav-text"> Manage Sellers </span>
//               </div>
//               {openMenu === "Sellerprodlist" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/sellerReglist">
//                       Seller Registration List
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/sellerorderlist">
//                       Seller Product List
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>


//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("orders")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <RiShoppingBag4Line />
//                 </span>
//                 <span className="nav-text"> Orders </span>
//               </div>
//               {openMenu === "orders" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/order-list">
//                       List
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/order-cart">
//                       Cart
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/order-checkout">
//                       Check Out
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("inventory")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <TbCube />
//                 </span>
//                 <span className="nav-text"> Inventory </span>
//               </div>

//               {openMenu === "inventory" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/inventory-warehouse">
//                       Warehouse
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link
//                       className="sub-nav-link"
//                       to="/inventory-received-orders"
//                     >
//                       Received Orders
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("purchase")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <CiCreditCard1 />
//                 </span>
//                 <span className="nav-text"> Return Management </span>
//               </div>
//               {openMenu === "purchase" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/return-list">
//                       Return Orders
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/cancle-list">
//                       Cancelled Orders
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/purchase-return">
//                       Return
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("invoice")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <BsCardList />
//                 </span>
//                 <span className="nav-text"> Invoices </span>
//               </div>
//               {openMenu === "invoice" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/invoice-list">
//                       List
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/invoice-detail">
//                       Details
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/invoice-add">
//                       Create
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <Link className="nav-link" to="/coupon-list">
//                 <span className="nav-icon">
//                   <BsCardList />
//                 </span>
//                 <span className="nav-text"> Coupons </span>
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/review-list">
//                 <span className="nav-icon">
//                   <BsCardList />
//                 </span>
//                 <span className="nav-text">Review</span>
//               </Link>
//             </li>

//             <li className="nav-item">
//               <Link className="nav-link" to="/notification-list">
//                 <span className="nav-icon">
//                   <BsCardList />
//                 </span>
//                 <span className="nav-text">Notification </span>
//               </Link>
//             </li>

//             <li className="menu-title mt-2">Users</li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/permission">
//                 <span className="nav-icon">
//                   <BsCardChecklist />
//                 </span>
//                 <span className="nav-text"> Permissions </span>
//               </Link>
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("customer")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <FaUsers />
//                 </span>
//                 <span className="nav-text"> Customers </span>
//               </div>
//               {openMenu === "customer" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/customer-list">
//                       List
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/customer-detail">
//                       Details
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("contact")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <FaUsers />
//                 </span>
//                 <span className="nav-text"> Contact </span>
//               </div>
//               {openMenu === "contact" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/contactUS">
//                       Contact List
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/contact-detail">
//                       Contact Details
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>
//             {/* <li className="nav-item">
//               <Link
//                 className="nav-link menu-arrow"
//                 to="#sidebarSellers"
//                 data-bs-toggle="collapse"
//                 role="button"
//                 aria-expanded="false"
//                 aria-controls="sidebarSellers"
//               >
//                 <span className="nav-icon">
//                   <AiTwotoneShop />
//                 </span>
//                 <span className="nav-text"> Seller </span>
//               </Link>
//               <div className="collapse" id="sidebarSellers">
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-list">
//                       Seller List
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-detail">
//                       Details
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-edit">
//                       Edit
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-add">
//                       Create
//                     </Link>
//                   </li>
//                 </ul>
//               </div>
//             </li> */}

//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("vendor")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <AiTwotoneShop />
//                 </span>
//                 <span className="nav-text"> Vendor </span>
//               </div>
//               {openMenu === "vendor" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/vendor-register">
//                       Vendor Register
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/vendor-list">
//                       List
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li className="menu-title mt-2">Seller</li>
//             <li className="nav-item">
//               <div
//                 className="nav-link menu-arrow"
//                 onClick={() => toggleMenu("seller")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="nav-icon">
//                   <AiTwotoneShop />
//                 </span>
//                 <span className="nav-text"> Seller </span>
//               </div>
//               {openMenu === "seller" && (
//                 <ul className="nav sub-navbar-nav">
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-dashboard">
//                       <span className="nav-icon me-1">
//                         <MdOutlineWidgets />
//                       </span>
//                       Dashboard
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <div
//                       className={`sub-nav-link menu-arrow ${openSellerProduct ? "show" : ""}`}
//                       aria-expanded={openSellerProduct}
//                       style={{ cursor: "pointer" }}
//                       onClick={() => setOpenSellerProduct(prev => !prev)}
//                     >
//                       <span className="nav-icon me-1">
//                         <FaList />
//                       </span>
//                       Listings
//                     </div>

//                     <div className={`collapse ${openSellerProduct ? "show" : ""}`}>
//                       <ul className="nav sub-navbar-nav ">
//                         <li className="sub-nav-item">
//                           <Link className="sub-nav-link" to="/sellerproduct">
//                             <span className="nav-icon me-1">
//                               <FaDatabase />
//                             </span>
//                             My Listings
//                           </Link>
//                         </li>

//                         <li className="sub-nav-item">
//                           <Link className="sub-nav-link" to="/add-seller-product">
//                             <span className="nav-icon me-1">
//                               <Fa42Group />
//                             </span>
//                             Add New Listing
//                           </Link>
//                         </li>

//                         <li className="sub-nav-item">
//                           <Link className="sub-nav-link" to="/Tract-Seller-Order">
//                             <span className="nav-icon me-1">
//                               <FaRightToBracket />
//                             </span>
//                             Track Request
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-order">
//                       <span className="nav-icon me-1">
//                         <FaJediOrder />
//                       </span>
//                       Order
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-blog">
//                       <span className="nav-icon me-1">
//                         <FaBlog />
//                       </span>
//                       Blogs
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/Marketingcenter">
//                       <span className="nav-icon me-1">
//                         <FaAlignCenter />
//                       </span>
//                       Marketing Center
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-finance">
//                       <span className="nav-icon me-1">
//                         <FaFaceGrinSquintTears />
//                       </span>
//                       Finance
//                     </Link>
//                   </li>
//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-shop">
//                       <span className="nav-icon me-1">
//                         <FaShop />
//                       </span>
//                       Shop
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/seller-contact">
//                       <span className="nav-icon me-1">
//                         <FaUsers />
//                       </span>
//                       Contact
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/report">
//                       <span className="nav-icon me-1">
//                         <FaRepublican />
//                       </span>
//                       Report
//                     </Link>
//                   </li>

//                   <li className="sub-nav-item">
//                     <Link className="sub-nav-link" to="/setting">
//                       <span className="nav-icon me-1">
//                         {/* <i class="fa-solid fa-gear fs-24 align-middle" style={{fontSize:"10px"}}></i> */}
//                       </span>
//                       Setting
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;


import React, { useEffect, useState } from "react";
import { MdOutlineWidgets } from "react-icons/md";
import { LuClipboardList } from "react-icons/lu";
import { Link, useLocation } from "react-router-dom";
import { TbCube } from "react-icons/tb";
import { RiShoppingBag4Line } from "react-icons/ri";
import { CiCreditCard1 } from "react-icons/ci";
import { BsCardList, BsCardChecklist } from "react-icons/bs";
import {
  FaAlignCenter, FaBlog, FaDatabase, FaJediOrder,
  FaList, FaRepublican, FaUsers
} from "react-icons/fa";
import { AiTwotoneShop } from "react-icons/ai";
import {
  Fa42Group, FaFaceGrinSquintTears,
  FaRightToBracket, FaShop
} from "react-icons/fa6";

const SlideToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Sidebar = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [openSellerProduct, setOpenSellerProduct] = useState(false);
  const [role, setRole] = useState(localStorage.getItem("role") || "");

  // Listen for login/logout events to update role dynamically
  useEffect(() => {
    const handleRoleChange = () => {
      setRole(localStorage.getItem("role") || "");
    };
    window.addEventListener("sellerLoggedIn", handleRoleChange);
    window.addEventListener("storage", handleRoleChange);
    return () => {
      window.removeEventListener("sellerLoggedIn", handleRoleChange);
      window.removeEventListener("storage", handleRoleChange);
    };
  }, []);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const isAdmin = role === "admin";
  const isSeller = role === "seller";

  return (
    <div>
      <SlideToTop />
      <div className="main-nav">

        {/* Logo */}
        <div className="logo-box">
          <Link to="/" className="logo-dark">
            <img src="/images/logo.jpeg" className="logo-sm" alt="logo sm" />
            <img src="/images/logo.jpeg" className="logo-lg" alt="logo dark" style={{ height: "100px" }} />
          </Link>
          <Link to="/" className="logo-light">
            <img src="/images/logo.jpeg" className="logo-sm" alt="logo sm" />
            <img src="/images/logo.jpeg" className="logo-lg" alt="logo light" />
          </Link>
        </div>

        <button type="button" className="button-sm-hover" aria-label="Show Full Sidebar">
          <i className="bx bx-menu button-sm-hover-icon" />
        </button>

        <div className="scrollbar" data-simplebar="">
          <ul className="navbar-nav" id="navbar-nav">

            {/* ───────── ADMIN MENU ───────── */}
            {isAdmin && (
              <>
                <li className="menu-title">General</li>

                {/* Dashboard */}
                <li className="nav-item">
                  <Link className="nav-link" to="/admin-dashboard">
                    <span className="nav-icon"><MdOutlineWidgets /></span>
                    <span className="nav-text">Dashboard</span>
                  </Link>
                </li>

                {/* Master */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("master")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><LuClipboardList /></span>
                    <span className="nav-text">Master</span>
                  </div>
                  {openMenu === "master" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/category-list">Categories</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/sub-category-list">Sub-Category</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/product-list">Product</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/attribute-list">Attribute</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/brand-list">Brand</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/color-list">Color</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/size-list">Size</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/unit-list">Product Unit</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/discount-list">Discount</Link></li>
                    </ul>
                  )}
                </li>

                {/* Website Manager */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("websitemanager")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><LuClipboardList /></span>
                    <span className="nav-text">Website Manager</span>
                  </div>
                  {openMenu === "websitemanager" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/Banner">Banner Master</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/Rising">Top Deals</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/Fashiontopdeals">Fashion Top Deals</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/ShopFavorites">Shop Your Favorites</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/Offer">Special Offers</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/GlobalBrand">Grand Global Brands</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/ShopByCategory">Shop By Category</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/ShopByCategory">Product Section</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/TopPick">Top Pick</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/CrazyDeals">Crazy Deals</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/Productfu">Products for you</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/Advertisement">Advertisement</Link></li>
                    </ul>
                  )}
                </li>

                {/* Manage Sellers */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("Sellerprodlist")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><RiShoppingBag4Line /></span>
                    <span className="nav-text">Manage Sellers</span>
                  </div>
                  {openMenu === "Sellerprodlist" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/sellerReglist">Seller Registration List</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/sellerorderlist">Seller Product List</Link></li>
                    </ul>
                  )}
                </li>

                {/* Orders */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("orders")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><RiShoppingBag4Line /></span>
                    <span className="nav-text">Orders</span>
                  </div>
                  {openMenu === "orders" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/order-list">List</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/order-cart">Cart</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/order-checkout">Check Out</Link></li>
                    </ul>
                  )}
                </li>

                {/* Inventory */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("inventory")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><TbCube /></span>
                    <span className="nav-text">Inventory</span>
                  </div>
                  {openMenu === "inventory" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/inventory-warehouse">Warehouse</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/inventory-received-orders">Received Orders</Link></li>
                    </ul>
                  )}
                </li>

                {/* Return Management */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("purchase")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><CiCreditCard1 /></span>
                    <span className="nav-text">Return Management</span>
                  </div>
                  {openMenu === "purchase" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/return-list">Return Orders</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/cancle-list">Cancelled Orders</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/purchase-return">Return</Link></li>
                    </ul>
                  )}
                </li>

                {/* Invoices */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("invoice")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><BsCardList /></span>
                    <span className="nav-text">Invoices</span>
                  </div>
                  {openMenu === "invoice" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/invoice-list">List</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/invoice-detail">Details</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/invoice-add">Create</Link></li>
                    </ul>
                  )}
                </li>

                {/* Coupons */}
                <li className="nav-item">
                  <Link className="nav-link" to="/coupon-list">
                    <span className="nav-icon"><BsCardList /></span>
                    <span className="nav-text">Coupons</span>
                  </Link>
                </li>

                {/* Review */}
                <li className="nav-item">
                  <Link className="nav-link" to="/review-list">
                    <span className="nav-icon"><BsCardList /></span>
                    <span className="nav-text">Review</span>
                  </Link>
                </li>

                {/* Notification */}
                <li className="nav-item">
                  <Link className="nav-link" to="/notification-list">
                    <span className="nav-icon"><BsCardList /></span>
                    <span className="nav-text">Notification</span>
                  </Link>
                </li>

                {/* Users section */}
                <li className="menu-title mt-2">Users</li>

                {/* Permissions */}
                <li className="nav-item">
                  <Link className="nav-link" to="/permission">
                    <span className="nav-icon"><BsCardChecklist /></span>
                    <span className="nav-text">Permissions</span>
                  </Link>
                </li>

                {/* Customers */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("customer")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><FaUsers /></span>
                    <span className="nav-text">Customers</span>
                  </div>
                  {openMenu === "customer" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/customer-list">List</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/customer-detail">Details</Link></li>
                    </ul>
                  )}
                </li>

                {/* Contact */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("contact")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><FaUsers /></span>
                    <span className="nav-text">Contact</span>
                  </div>
                  {openMenu === "contact" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/contactUS">Contact List</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/contact-detail">Contact Details</Link></li>
                    </ul>
                  )}
                </li>

                {/* Vendor */}
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("vendor")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><AiTwotoneShop /></span>
                    <span className="nav-text">Vendor</span>
                  </div>
                  {openMenu === "vendor" && (
                    <ul className="nav sub-navbar-nav">
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/vendor-register">Vendor Register</Link></li>
                      <li className="sub-nav-item"><Link className="sub-nav-link" to="/vendor-list">List</Link></li>
                    </ul>
                  )}
                </li>
              </>
            )}

            {/* ───────── SELLER MENU ───────── */}
            {isSeller && (
              <>
                <li className="menu-title">Seller</li>
                <li className="nav-item">
                  <div className="nav-link menu-arrow" onClick={() => toggleMenu("seller")} style={{ cursor: "pointer" }}>
                    <span className="nav-icon"><AiTwotoneShop /></span>
                    <span className="nav-text">Seller</span>
                  </div>
                  {openMenu === "seller" && (
                    <ul className="nav sub-navbar-nav">

                      {/* Dashboard */}
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/seller-dashboard">
                          <span className="nav-icon me-1"><MdOutlineWidgets /></span>
                          Dashboard
                        </Link>
                      </li>

                      {/* Listings (nested) */}
                      <li className="sub-nav-item">
                        <div
                          className={`sub-nav-link menu-arrow ${openSellerProduct ? "show" : ""}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpenSellerProduct(prev => !prev)}
                        >
                          <span className="nav-icon me-1"><FaList /></span>
                          Listings
                        </div>
                        <div className={`collapse ${openSellerProduct ? "show" : ""}`}>
                          <ul className="nav sub-navbar-nav">
                            <li className="sub-nav-item">
                              <Link className="sub-nav-link" to="/sellerproduct">
                                <span className="nav-icon me-1"><FaDatabase /></span>
                                My Listings
                              </Link>
                            </li>
                            <li className="sub-nav-item">
                              <Link className="sub-nav-link" to="/add-seller-product">
                                <span className="nav-icon me-1"><Fa42Group /></span>
                                Add New Listing
                              </Link>
                            </li>
                            <li className="sub-nav-item">
                              <Link className="sub-nav-link" to="/Tract-Seller-Order">
                                <span className="nav-icon me-1"><FaRightToBracket /></span>
                                Track Request
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>

                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/seller-order">
                          <span className="nav-icon me-1"><FaJediOrder /></span>
                          Order
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/seller-blog">
                          <span className="nav-icon me-1"><FaBlog /></span>
                          Blogs
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/Marketingcenter">
                          <span className="nav-icon me-1"><FaAlignCenter /></span>
                          Marketing Center
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/seller-finance">
                          <span className="nav-icon me-1"><FaFaceGrinSquintTears /></span>
                          Finance
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/seller-shop">
                          <span className="nav-icon me-1"><FaShop /></span>
                          Shop
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/seller-contact">
                          <span className="nav-icon me-1"><FaUsers /></span>
                          Contact
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/report">
                          <span className="nav-icon me-1"><FaRepublican /></span>
                          Report
                        </Link>
                      </li>
                      <li className="sub-nav-item">
                        <Link className="sub-nav-link" to="/setting">
                          <span className="nav-icon me-1"></span>
                          Setting
                        </Link>
                      </li>

                    </ul>
                  )}
                </li>
              </>
            )}

          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;